<hmf-progress-ring
	[variant]="'gold'"
	[targetBalance]="salesTarget"
	[currentBalance]="currentSalesBalance"
	[animateLoading]="isGold"
	[size]="size">
</hmf-progress-ring>
